import { useEffect } from "react";
import "@/App.css";
import Noblesse from "@/pages/Noblesse";

function App() {
  useEffect(() => {
    document.title = "NOBLESSE – Prémium masszázs | Rostás Ibolya";
  }, []);

  return (
    <div className="App bg-anthracite-950 min-h-screen">
      <Noblesse />
    </div>
  );
}

export default App;
